import React from "react";
import "./styles/dashboard.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AssessmentToolPage from "./pages/AssessmentToolPage";
import LoginPage from "./pages/LoginPage";
import PortaalPage from "./pages/PortaalPage";
import AdminPageRoute from "./pages/AdminPage";
import ProjectleidersPage from "./pages/ProjectleidersPage";
import VolwassenheidPage from "./pages/VolwassenheidPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/admin" element={<AdminPageRoute />} />
        <Route path="/" element={<PortaalPage />} />
        <Route path="/ea/:projectId" element={<AssessmentToolPage />} />
        <Route path="/pl/:projectId" element={<ProjectleidersPage />} />
        <Route path="/vw/:projectId" element={<VolwassenheidPage />} />
      </Routes>
    </BrowserRouter>
  );
}